<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">上传组合</div>
    <div class="third-title"><span>组合</span></div>
    <div class="order-detail-basic">
      <el-form :model="elementVo" label-width="100px" ref="formRef">
        <el-form-item label="素材标签:">
          <el-checkbox-group v-model="elementVo.labelIds">
            <el-checkbox v-for="item in tageList" :key="item.id" :label="item.id">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="素材:">
          <input id="updateFile" @change="uploadFile" type="file" style="display:none">
          <el-button type="primary" @click="clickInputFile" round>上传</el-button>
          <el-table :data="fileList" border style="width:500px;margin:10px 0 0 0 ">
            <el-table-column prop="fileName" label="文件"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column label="操作">
              <template>
                <span class="color-blue" @click="fileList=[],elementVo.pathVos[0].filePath =''">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="缩略图:">
          <input id="updateImg" @change="uploadImg" type="file" style="display:none">
          <el-button type="primary" @click="clickInputIMg" round>上传</el-button>
          <!-- <div v-show="elementVo.pathVos[0].thumbnail" style="margin:10px 0 0 0;width:200px;height:200px;border:1px solid #000;position:relative">
              <i @click="elementVo.pathVos[0].thumbnail =''" style="position: absolute;top: 0;right: 0;font-size: 20px;border: 1px solid #ccc;" class="el-icon-close"></i>
              <img  style="width:200px" :src="elementVo.pathVos[0].thumbnail" alt="">
            </div> -->
          <div style="margin-top:10px;">
            <div class="upload_warp_img" v-show="elementVo.pathVos[0].thumbnail">
              <div class="upload_warp_img_div">
                <div class="upload_img">
                  <img :src="elementVo.pathVos[0].thumbnail">
                  <!-- <el-image :src="item" :fit="contain"></el-image> -->
                </div>
                <div class="upload_warp_img_div_top">
                  <p class="upload_warp_img_div_del color-blue" @click="elementVo.pathVos[0].thumbnail =''">删除图片</p>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="前端是否显示:">
          <el-switch v-model="elementVo.isShow" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)"
            inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="add">确定</el-button>
    </div>
  </div>
</template>
 <script>
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg.js'
import { labelGetLabelList, elementAddCombo } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  data () {
    return {
      awsSdk: null,
      checkList: [],
      fileList: [],
      elementVo: {
        pathVos: [
          {
            filePath: '',
            thumbnail: ''
          }
        ],
        isShow: 0,
        labelIds: []
      },
      searchLabelVo: {
        label: '',
        labelBelong: '',
        labelBelongCode: 'COMBO',
        page: 0
      },
      tageList: []
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getTaglist()
  },
  methods: {
    // 工程文件
    uploadFile (e) {
      if (e.target.files[0].name.split('.')[1] === 'ptf') {
        this.fileList = [
          {
            fileName: e.target.files[0].name,
            status: '正在上传'
          }
        ]
        uploadWebImg(e.target.files[0], this.$store.state.awsSdk.product.s3).then(res => {
          this.elementVo.pathVos[0].filePath = res
          this.fileList[0].status = '上传成功'
          this.$forceUpdate()
        })
      } else {
        this.$message.error('请上传正确的工程文件')
      }
    },
    // 缩略图
    uploadImg (e) {
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.target.files[0], this.$store.state.awsSdk.product.s3).then(res => {
        this.elementVo.pathVos[0].thumbnail = res
      })
    },
    clickInputFile () {
      document.getElementById('updateFile').click()
    },
    clickInputIMg () {
      document.getElementById('updateImg').click()
    },
    add () {
      if (this.elementVo.labelIds.length === 0) {
        this.$message.error('未选择素材标签')
        return
      }
      if (this.fileList.length === 0) {
        this.$message.error('未上传素材')
        return
      }
      if (this.elementVo.pathVos[0].thumbnail === '') {
        this.$message.error('未上传缩略图')
        return
      }
      elementAddCombo(this.elementVo).then(res => {
        if (res.data.success) {
          this.$message.success('创建成功')
          this.$router.go(-1)
        }
      })
    },
    // 获取素材标签
    getTaglist () {
      labelGetLabelList({ pageNum: 1, pageSize: 10, searchLabelVo: this.searchLabelVo }).then(res => {
        if (res.data.success) {
          this.tageList = res.data.data.records
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
@deep: ~">>>";
.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }
    .el-input {
      width: 110px;
    }
    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }
  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;
    i {
      font-size: 20px;
      color: #999;
    }
  }
  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;
    i {
      color: #fff;
    }
  }
}
.upload_warp_img {
  overflow: hidden;
  display: flex;
  .upload_warp_img_div {
    width: 180px;
    margin: 0 5px;
    border: 1px solid #d2d2d2;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    height: 200px;
  }
}
.upload_img {
  flex: 1;
  position: relative;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}
.upload_warp_img_div_top {
  display: flex;
  width: 100%;
  align-items: center;
  background: #f9fafc;
  justify-content: center;
  line-height: 36px;
  border-top: 1px solid #ececec;
}
.upload_warp_img_div_del {
  padding-left: 10px;
}
</style>
